var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.27273 2.72727V0L3.63636 3.63636L7.27273 7.27273V4.54545C10.2818 4.54545 12.7273 6.99091 12.7273 10C12.7273 10.9182 12.5 11.7909 12.0909 12.5455L13.4182 13.8727C14.1548 12.7154 14.5458 11.3719 14.5455 10C14.5455 5.98182 11.2909 2.72727 7.27273 2.72727ZM7.27273 15.4545C4.26364 15.4545 1.81818 13.0091 1.81818 10C1.81818 9.08182 2.04545 8.20909 2.45455 7.45455L1.12727 6.12727C0.390684 7.28463 -0.000381468 8.62813 2.79221e-07 10C2.79221e-07 14.0182 3.25455 17.2727 7.27273 17.2727V20L10.9091 16.3636L7.27273 12.7273V15.4545Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.24997 9C7.4459 8.99999 7.63752 9.05754 7.80102 9.1655C7.96452 9.27345 8.09271 9.42707 8.16966 9.60725C8.2466 9.78744 8.26892 9.98626 8.23384 10.179C8.19875 10.3718 8.10782 10.55 7.97232 10.6915C7.83682 10.833 7.66273 10.9316 7.47167 10.9751C7.28061 11.0185 7.08101 11.0048 6.89765 10.9358C6.71429 10.8668 6.55525 10.7454 6.44029 10.5867C6.32532 10.428 6.2595 10.2391 6.251 10.0434L6.25 9.99997L6.251 9.95657C6.26218 9.69913 6.37232 9.45594 6.55844 9.27772C6.74455 9.09951 6.99229 9.00001 7.24997 9Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/Reset.b3923704227b7670241b14463aacfa2a.svg";
export { ForwardRef as ReactComponent };